module.exports = __webpack_public_path__ + "static/media/futuristicxme.c6d3f0b3.png";